<ngx-select-dropdown
  class="combobox"
  [ngClass]="[
    buttonDropdown ? 'combobox--button' : '',
    selectedValue ? 'combobox--selected-value' : '',
    mobileRoundedCorners ? 'combobox--mobile-rounded-corners' : ''
  ]"
  [disabled]="isDisabled"
  (change)="onChangeValue($event)"
  (open)="onOpen()"
  (click)="onSetDropdownHeightAndFilterDuplicates($event)"
  [multiple]="multiple"
  [config]="config"
  [options]="optionsList"
  [(ngModel)]="value"
>
</ngx-select-dropdown>
